/**
 * Gets a display name for an entity, preferring full name over email.
 *
 * If both first_name and last_name are present, returns them combined.
 * Otherwise, falls back to the email address.
 *
 * @param entity - Entity object with optional first_name, last_name, and email properties
 * @returns Display name string, or empty string if entity is falsy
 *
 * @example
 * ```typescript
 * getEntityName({ first_name: 'John', last_name: 'Doe', email: 'john@example.com' })
 * // returns 'John Doe'
 *
 * getEntityName({ first_name: 'John', email: 'john@example.com' })
 * // returns 'john@example.com'
 *
 * getEntityName({ email: 'john@example.com' })
 * // returns 'john@example.com'
 *
 * getEntityName(null)
 * // returns ''
 * ```
 */
export const getEntityName = (entity: any): string => {
  if (!entity) return ''
  let name

  if (entity.first_name && entity.last_name) {
    name = `${entity.first_name} ${entity.last_name}`
  } else {
    name = entity.email
  }

  return name
}
